/**
 * Shared centered branded card for every auth screen (login, forgot/reset
 * password). One layout so the flows look identical — factored out once a
 * second and third screen needed the same header + card LoginPage already had.
 */
import type { ReactNode } from "react";

import { useAuth } from "@/auth/AuthContext";
import Brand from "@/components/Brand";

export function AuthShell({ children }: { children: ReactNode }) {
  const { appTagline } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-fg">
      <div className="w-full max-w-sm">
        {/* The lockup carries the wordmark, so the name is not repeated as text
            beside it — it reaches assistive tech through the image's alt. */}
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <Brand variant="lockup" size={112} />
          {appTagline && <p className="text-xs text-fg-subtle">{appTagline}</p>}
        </div>
        <div className="space-y-4 rounded-lg border border-border bg-bg-elevated p-6 shadow-sm">
          {children}
        </div>
      </div>
    </div>
  );
}

export const authInputClass =
  "w-full rounded-md border border-border bg-bg px-3 py-2 text-sm outline-none focus:border-brand focus:ring-1 focus:ring-brand";

export const authButtonClass =
  "w-full rounded-md bg-brand px-3 py-2 text-sm font-medium text-white transition-opacity disabled:opacity-60";

export const authErrorClass = "text-sm";
